module.exports = __webpack_public_path__ + "img/45.b9f05d90.jpg";